import { isQuadkey, Quadkey } from '../../../../Quadkey'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const quadkeysFromGeotokensEvent = (event: any) => {
  const result: Quadkey[] = []
  const { from, to, quadkey } = event
  if (from && isQuadkey(from)) {
    result.push(from as Quadkey)
  }
  if (to && isQuadkey(to)) {
    result.push(to as Quadkey)
  }
  if (quadkey && isQuadkey(quadkey)) {
    result.push(quadkey)
  }
  return result
}
